

























import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"

@Component({
  computed: {
    ...mapState({
      dialog: 'dialog'
    })
  }
})
export default class BookingReadBusinessMessage extends Vue {

  dialog!: any

  isSaveServiceCandidateMessage = false

  async saveServiceCandidateMessage() {
    this.isSaveServiceCandidateMessage = true
    await this.$store
      .dispatch(
        "ServiceCandidate/businessMessage",
        this.dialog.selectedServiceCandidate
      )
      .catch(({ response }) => {
        this.$store.commit("SET_SNACKBAR", {
          show: true,
          type: "error",
          message: response.data.error,
        })
      })
    this.isSaveServiceCandidateMessage = false
  }

}
